export const PENDING = 'PENDING';
export const SUCCESS = 'SUCCESS';
export const CONFIRMATION = 'CONFIRMATION';
export const CHANGE = 'CHANGE_EMAIL';
